
export const GET_SIGNUP_REQUEST="GET_SIGNUP_REQUEST";
export const GET_SIGNUP_SUCCESS="GET_SIGNUP_SUCCESS";
export const GET_SIGNUP_FAILURE="GET_SIGNUP_FAILURE";

export const POST_SIGNUP_REQUEST="POST_SIGNUP_REQUEST";
export const POST_SIGNUP_SUCCESS="POST_SIGNUP_SUCCESS";
export const POST_SIGNUP_FAILURE="POST_SIGNUP_FAILURE";

export const GET_LOGIN_REQUEST="GET_LOGIN_REQUEST";
export const GET_LOGIN_SUCCESS="GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILURE="GET_LOGIN_FAILURE";

export const GET_LOGOUT_REQUEST="GET_LOGOUT_REQUEST";
export const GET_LOGOUT_SUCCESS="GET_LOGOUT_SUCCESS";
export const GET_LOGOUT_FAILURE="GET_LOGOUT_FAILURE";

export const GET_FISTNAME_REQUEST="GET_FISTNAME_REQUEST";
export const GET_FISTNAME_SUCCESS="GET_FISTNAME_SUCCESS";
export const GET_FISTNAME_FAILURE="GET_FISTNAME_FAILURE";